import { useCallback, useContext, useEffect, useState } from "react";

// Context
import SnackbarContext from "../../../context/psikotest/SnackbarContext";

// Handler
import errorHandler from "../../../helper/psikotest/errorHandler";

// Controller
import ParticipantSession from "../../../controller/psikotest/psikotest_participant/session";
import { CheckCircleIcon, ClockIcon } from "@heroicons/react/24/outline";

function SubtestSrq20(props: { assessment_participant_session: TPPAssessmentParticipantSession, closeSession: () => void }) {
    // Context
    const { setNotif } = useContext(SnackbarContext);

    // state
    const [srq20, setSrq20] = useState<TPSSrq20>()
    const [srq20_questionary, setSrq20Questionary] = useState<TPSSrq20Questionary[]>([])
    const [srq20_questionary_answer, setSrq20QuestionaryAnswer] = useState<TPSAssessmentParticipantSrq20SessionAnswer>()
    const [answer_questionary, setAnswerQuestionary] = useState<{ number: Number, answer: string }[]>([])

    // get doc
    const getDoc = useCallback(async () => {
        try {
            // get all question in subtest id
            const psc = new ParticipantSession();
            let resSrq20 = await psc.getSrq20();
            setSrq20(resSrq20.data.row)
            let resQuestionarySrq20 = await psc.getQuestionarySrq20();
            setSrq20Questionary(resQuestionarySrq20.data.list)
            let resQuestionaryAnswerSrq20 = await psc.getQuestionaryAnswerSrq20(props.assessment_participant_session.id)
            setSrq20QuestionaryAnswer(resQuestionaryAnswerSrq20.data.row)
            // set answer questionary
            if ((JSON.parse(resQuestionaryAnswerSrq20.data.row.answer)).length === 0) {
                // create empty object with same length of srq20 questionary
                setAnswerQuestionary(resQuestionarySrq20.data.list.map((q: TPSSrq20Questionary) => {
                    return { number: q.number, answer: "" }
                }))
            } else {
                setAnswerQuestionary(JSON.parse(resQuestionaryAnswerSrq20.data.row.answer))
            }
        } catch (error) {
            const errorMessage = errorHandler(error);
            setNotif({ type: "error", message: errorMessage });
        }
    }, [setNotif, props.assessment_participant_session.id]);

    useEffect(() => {
        getDoc();
    }, [getDoc]);

    // track srq20_questionary
    useEffect(() => {
        //console.log(srq20_questionary)
    }, [srq20_questionary]);

    // track answer_questionary
    useEffect(() => {
        //console.log(answer_questionary)
    }, [answer_questionary]);

    // handleAnswer
    const handleAnswer = async (index: number, answer: string) => {
        try {
            //console.log(index, answer, point)
            // set answer
            // copy answer
            const c_answer = [...answer_questionary]
            c_answer.splice(index, 1, { number: c_answer[index].number, answer: answer })
            // set result point
            const c_result_point = {
                yes: c_answer.filter(c => c.answer === "yes").length,
                no: c_answer.filter(c => c.answer === "no").length,
            }
            // save answer
            if (srq20_questionary_answer) {
                const psc = new ParticipantSession();
                await psc.saveQuestionaryAnswerSrq20(props.assessment_participant_session.id, {
                    ...srq20_questionary_answer,
                    answer: JSON.stringify(c_answer),
                    result: JSON.stringify(c_result_point)
                });
                setAnswerQuestionary(c_answer)
            }
        } catch (error) {
            const errorMessage = errorHandler(error);
            setNotif({ type: "error", message: errorMessage });
        }
    }

    return (
        <div className="h-[94%] overflow-auto">
            <div className="flex flex-col items-center">
                <div className="text-sm md:text-base max-w-5xl text-center py-3">
                    {srq20?.mdi}
                </div>
            </div>
            <div className="text-sm md:text-base border-b flex flex-col items-center pb-20">
                <div className="max-w-5xl w-full">
                    <div className="">
                        <div className="flex w-full bg-slate-800 text-white font-semibold">
                            <div className="w-1/12 text-center flex justify-center items-center border p-1">No</div>
                            <div className="w-6/12 text-center flex justify-center items-center border p-1">
                                Pertanyaan
                            </div>
                            <div className={`w-2/12 text-center flex justify-center items-center border p-1 cursor-pointer`}>
                                Ya
                            </div>
                            <div className={`w-2/12 text-center flex justify-center items-center border p-1 cursor-pointer`}>
                                Tidak
                            </div>
                            <div className="w-1/12 text-center flex justify-center items-center border p-1">
                                <CheckCircleIcon className="w-5 text-white" />
                            </div>
                        </div>
                    </div>
                    {srq20_questionary.map((srq20_q, index) => (
                        <div key={index} className="">
                            <div className="flex w-full">
                                <div className="w-1/12 text-center flex justify-center items-center border p-1">{srq20_q.number}</div>
                                <div className="w-6/12 text-center flex justify-center items-center border p-1">{srq20_q.question}</div>
                                <div
                                    className={`
                                        w-2/12 text-center flex justify-center items-center border p-1 cursor-pointer hover:bg-blue-200 hover:font-semibold hover:text-black
                                        ${answer_questionary?.[index]?.answer === "yes" ? "bg-green-200" : ""}
                                        ${answer_questionary?.[index]?.answer !== "yes" && answer_questionary?.[index]?.answer === "no" ? "bg-slate-100 text-gray-400" : ""}
                                    `}
                                    onClick={() => handleAnswer(index, "yes")}>
                                    Ya
                                </div>
                                <div
                                    className={`
                                        w-2/12 text-center flex justify-center items-center border p-1 cursor-pointer hover:bg-blue-200 hover:font-semibold hover:text-black
                                        ${answer_questionary?.[index]?.answer === "no" ? "bg-green-200" : ""}
                                        ${answer_questionary?.[index]?.answer !== "no" && answer_questionary?.[index]?.answer === "yes" ? "bg-slate-100 text-gray-400" : ""}
                                    `}
                                    onClick={() => handleAnswer(index, "no")}>
                                    Tidak
                                </div>
                                <div className={`w-1/12 text-center flex justify-center items-center border p-1 ${answer_questionary?.[index]?.answer !== "" ? "bg-green-100" : ""}`}>
                                    {answer_questionary?.[index]?.answer !== ""
                                        ? <CheckCircleIcon className="w-5 text-green-600" />
                                        : <ClockIcon className="w-5 text-gray-400" />
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="max-w-5xl w-full mt-3 flex justify-between items-center">
                    <div className="pl-2 md:pl-6 font-semibold">
                        {answer_questionary.filter(aq => aq.answer !== "").length}/{srq20_questionary.length}
                    </div>
                    {answer_questionary.filter(aq => aq.answer !== "").length !== srq20_questionary.length &&
                        <div className="px-3 text-red-500">Tombol <b>Finish</b> tersedia saat semua pernyataan telah dipilih</div>
                    }
                    <button
                        type="button"
                        className={`mx-3 md:mx-0 py-1 px-6 min-w-[80px] text-center cursor-pointer rounded text-white bg-red-500 hover:bg-red-600 disabled:bg-gray-300`}
                        onClick={() => props.closeSession()}
                        disabled={answer_questionary.filter(aq => aq.answer !== "").length !== srq20_questionary.length}>
                        Finish
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SubtestSrq20;
